"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactEmotion = _interopRequireWildcard(require("react-emotion"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var wrap = /*#__PURE__*/(0, _reactEmotion.keyframes)("from:{transform:scaleY(0);opacity:0;}to{transform:scaleY(1);opacity:1;}");
var StyledWrap = /*#__PURE__*/(0, _reactEmotion.default)('div', {
  target: "en5qbcw0"
})("transform:scaleY(0);opacity:0;transform-origin:top;animation:", wrap, " .2s linear forwards;background:", function (props) {
  return props.theme === 'dark' ? '#222' : '#fff';
}, ";border-style:solid;border-width:1px;border-color:", function (props) {
  return props.theme === 'dark' ? '#000' : '#E0E3E4';
}, ";");

var Wrap = function Wrap(_ref) {
  var children = _ref.children,
      setRef = _ref.setRef,
      isSubmenu = _ref.isSubmenu,
      theme = _ref.theme;
  return /*#__PURE__*/_react.default.createElement(StyledWrap, {
    theme: theme,
    innerRef: function innerRef(_innerRef) {
      if (typeof setRef === 'function') {
        setRef(_innerRef);
      }
    },
    "data-dropdown-submenu-wrap": isSubmenu,
    "data-dropdown-wrap": "true",
    className: "rounded box-shadow z4 border-gray-5"
  }, children);
};

Wrap.defaultProps = {
  children: null,
  setRef: null,
  isSubmenu: false,
  theme: 'light'
};
Wrap.propTypes = {
  setRef: _propTypes.default.func,
  children: _propTypes.default.node,
  isSubmenu: _propTypes.default.bool,
  theme: _propTypes.default.string
};
var _default = Wrap;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(wrap, "wrap", "/Users/darcy/sites/cs-theme/src/components/common/dropdown/wrap.js");
  reactHotLoader.register(StyledWrap, "StyledWrap", "/Users/darcy/sites/cs-theme/src/components/common/dropdown/wrap.js");
  reactHotLoader.register(Wrap, "Wrap", "/Users/darcy/sites/cs-theme/src/components/common/dropdown/wrap.js");
  reactHotLoader.register(_default, "default", "/Users/darcy/sites/cs-theme/src/components/common/dropdown/wrap.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();